import React from 'react';
import {formatPhoneString} from '../utils/StringUtils';

export default class DisplayLinks extends React.Component {
    static defaultProps = {
      target: '_blank'
    };
    getProtocol(item) {
        if(this.props.type != 'href') {
            return this.props.type + ":";
        }

        return item.startsWith('www.') ? 'http://' : '';
    }

    getFullHref(item) {
        var href = this.getProtocol(item.normalised) + item.normalised;

        if(this.props.type != 'href')
            return href;

        //If type is href, add http:// to start of link if needed, else return href as is
        return (
            this.props.type != 'href' ? 
            href : 
            ( ! href.startsWith('http://') ?
                "http://" + href : 
                href
            )
        );
    }

    render() {
    	var normalisedItems = [];
    	for (var i = this.props.values.length - 1; i >= 0; i--) {
    		var item = this.props.values[i];
    		item = item.replace(new RegExp(' ', 'g'), '')    		
    		// console.log(normalisedItems);

            var display = this.props.type == 'tel' ? formatPhoneString(this.props.values[i]) : this.props.values[i];

    		normalisedItems.push({
    			display : display,
    			normalised : item
    		});
    	}

        return (
        	<div className={this.props.className}>
	            {normalisedItems.map((item, index) => 
	                <span key={index}>
                        <a target={this.props.target} href={this.getFullHref(item)} style={{'display' : 'inline-block'}}>{item.display}</a>
	                    {index != normalisedItems.length - 1 && ", " }
                    </span>
	            )}
           	</div>
        );        
    }
}

DisplayLinks.propTypes = {
    values: React.PropTypes.array.isRequired
};


// WEBPACK FOOTER //
// ./app/components/DisplayLinks.js